<form [formGroup]="form"
      (ngSubmit)="onSubmit($event)">
  <div class="fields">
    <mat-form-field>
      <mat-label>Текст</mat-label>
      <input matInput
             formControlName="search"
             type="text"
             autocomplete="off"
             [autofocus]="['autofocus']">
    </mat-form-field>
  </div>
  <div class="buttons">
    <button mat-flat-button
            color="primary"
            type="submit"
            (click)="onSubmit($event)">Применить
    </button>
    <button mat-flat-button
            type="button"
            (click)="onClear($event)">Очистить
    </button>
  </div>
</form>
